export default __webpack_public_path__ + "static/media/security.bd849f57.svg";